import { memberDisplayNameFallback } from '@/i18n/user-display-name-copy';
import { CONNECT_SEARCH_MAX_LENGTH } from '@/convex/organizations/channels/connect_search_query.helpers';
import {
  connectSearchHitHref,
  connectSearchHitSnippet,
  type ConnectSearchHit,
} from '@/components/work-chats/connect-search-results';
import type { LinkResult } from './types';

/** Connect message search answers from two typed characters on. */
export const CONNECT_MESSAGE_MIN_TERM = 2;

/**
 * `searchConnectMessages` args for a command-menu term, or `null` when the
 * term is too short (the caller passes 'skip'). `in:`/`from:` filters pass
 * through untouched.
 */
export function connectMessageSearchArgs(
  orgSlug: string | undefined,
  term: string
): { orgSlug: string; query: string } | null {
  const query = term.trim().slice(0, CONNECT_SEARCH_MAX_LENGTH);
  if (!orgSlug || query.length < CONNECT_MESSAGE_MIN_TERM) return null;
  return { orgSlug, query };
}

/**
 * Command-menu rows for Connect hits: the message snippet as the title, the
 * chat (`#channel` or DM name) as the trailing hint, opening the message (or
 * its thread reply) on select.
 */
export function connectHitsToLinks(
  orgSlug: string,
  hits: readonly ConnectSearchHit[],
  limit: number,
  locale?: string
): LinkResult[] {
  return hits.slice(0, limit).map((hit) => ({
    id: `message:${hit.id}`,
    title: connectSearchHitSnippet(hit),
    href: connectSearchHitHref(orgSlug, hit),
    hint:
      hit.channelLabel ||
      (hit.channelKind === 'dm'
        ? memberDisplayNameFallback(locale)
        : hit.author || undefined),
    at: hit.createdAt,
  }));
}
